import { useState, useEffect } from 'react';
import { AppDispatch } from '../../../../core/store/store';
import { useDispatch } from 'react-redux';
import { onRequestRemoveAccount, onSendOtp } from '../store/auth/AuthThunk';
import { TextComponent } from '../../../../core/components/TextComponent';
import { Loading } from "../../../../core/icons/Loading";
import { Row } from "../../../../core/components/Row";
import { useAlert } from '../../../../core/hooks/useAlert';

interface TimerComponentProps {
  type: string; 
  initialTime?: number;
  phoneOrEmail?: string;
}

export const TimerComponent = ({ type, initialTime = 59 ,phoneOrEmail}:TimerComponentProps) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [canResend, setCanResend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch: AppDispatch = useDispatch();
  const { showAlert } = useAlert();
  useEffect(() => {
    if (timeLeft === 0) {
      setCanResend(true);
      return;
    }

    const timerId = setInterval(() => {
      setTimeLeft(prevTime => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft]);

  const handleResendOTP = async () => {
    setIsLoading(true);
    if(type==="3"){
      await dispatch(
        onRequestRemoveAccount()
      ).then((_)=>{
        setTimeLeft(initialTime);
        setCanResend(false);
      });
    } else {
      const result = await dispatch(
          onSendOtp({
              email: phoneOrEmail??'',
              type:type
          })
      );
      if (onSendOtp.fulfilled.match(result)) {
          setTimeLeft(initialTime);
          setCanResend(false);
      } else {
        showAlert({
          message: result.error.message || "Could not send the verification code right now.",
          type: "error",
        });
      }
    }
    setIsLoading(false);
  };

  return (
    <div>
      {!canResend ? (
        <TextComponent variant="h6" className="mt-3 text-gray-500">
        Resend OTP in <span className="text-primary font-bold">00:{timeLeft < 10 ? `0${timeLeft}` : timeLeft}</span>
      </TextComponent>
      ) : (
        <button type="button" className='text-primary' onClick={handleResendOTP} disabled={isLoading} >
          <Row crossAxisAlignment="center" className="gap-1">
            {isLoading ?
              <>
                <Loading /> 
                <TextComponent variant="h6">
                  Sending OTP
                </TextComponent>
              </>
              : 
              <TextComponent variant="h6">
                Resend OTP
              </TextComponent>
            }
          </Row>
        </button>
      )}
    </div>
  );
};
